export default function buildTree(flatRows) {
  if (!flatRows?.length) return [];

  const lookup = new Map();
  const roots = [];

  const rows = flatRows.map((row, index) => ({
    ...row,
    id: row.id ?? `__auto_${index}`,
  }));

  for (const row of rows) {
    lookup.set(row.id, { ...row, subRows: [] });
  }

  for (const row of rows) {
    const node = lookup.get(row.id);
    if (row.parentId == null || row.parentId === row.id) {
      roots.push(node);
    } else {
      const parent = lookup.get(row.parentId);
      if (parent) {
        parent.subRows.push(node);
      } else {
        roots.push(node);
      }
    }
  }

  return roots;
}
